import walletConnectLogo from "./images/wallet-connect-logo.svg";
import metaMaskLogo from "./images/metamask-logo.svg";
import logo from "./logo-white.png";
import frog_look_to_left_webp from "./images/frog-look-to-left.webp";
import frog_look_to_right_png from "./images/frog-look-to-right.png";
import frog_0 from "./images/frogs/frog-0.png";
import frog_1 from "./images/frogs/frog-1.png";
import frog_2 from "./images/frogs/frog-2.png";
import frog_3 from "./images/frogs/frog-3.png";
import frog_4 from "./images/frogs/frog-4.png";
import frog_5 from "./images/frogs/frog-5.png";
import frog_6 from "./images/frogs/frog-6.png";
import frog_7 from "./images/frogs/frog-7.png";
import frog_8 from "./images/frogs/frog-8.png";
import frog_9 from "./images/frogs/frog-9.png";

const frogs = [
  frog_0,
  frog_1,
  frog_2,
  frog_3,
  frog_4,
  frog_5,
  frog_6,
  frog_7,
  frog_8,
  frog_9,
];

export {
  walletConnectLogo,
  metaMaskLogo,
  logo,
  frog_look_to_left_webp,
  frog_look_to_right_png,
  frogs,
};
